// extracted by mini-css-extract-plugin
export var actionSelect = "_sg-0";